import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './Final_HD.mp4'


const _hoisted_1 = { class: "element" }

import { ref, reactive, onMounted } from "vue";
import Player from "xgplayer";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const datas: any = reactive({
  player: "",
});
// 初始化西瓜视频
const initPlayer = () => {
  datas.player = new Player({
    id: "play",
    volume: 0,
    ignores: ["replay"],
    controls: false,
    url: "./Final_HD.mp4",
    // poster: props.poster,

    height: "100vh",
    // autoplay: true,
    autoplay: true,
    lang: "zh-cn",
    width: "100%",
    // thumbnail: {
    //   pic_num: 44,
    //   width: 160,
    //   height: 90,
    //   col: 10,
    //   row: 10,
    //   urls: ["//lf9-cdn-tos.bytecdntp.com/cdn/expire-1-M/byted-player-videos/1.0.0/xgplayer-demo-thumbnail.jpg"],
    // },
    // danmu: {
    //   comments: [
    //     {
    //       duration: 15000,
    //       id: "1",
    //       start: 3000,
    //       txt: "长弹幕长弹幕长弹幕长弹幕长弹幕",
    //       style: {
    //         //弹幕自定义样式
    //         color: "#ff9500",
    //         fontSize: "20px",
    //         border: "solid 1px #ff9500",
    //         borderRadius: "50px",
    //         padding: "5px 11px",
    //         backgroundColor: "rgba(255, 255, 255, 0.1)",
    //       },
    //     },
    //   ],
    //   area: {
    //     start: 0,
    //     end: 1,
    //   },
    // },
  });
};
onMounted(() => {
  initPlayer();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("video", {
      style: {"width":"100%"},
      autoplay: "",
      muted: "",
      src: _imports_0
    }, null, -1)
  ]))]))
}
}

})